import React from 'react';
import DaumPostcode from 'react-daum-postcode';

const Postcode = ({ setValues, form, handleCancel }) => {
  const handleComplete = (data) => {
    let fullAddress = data.address;
    let extraAddress = '';

    if (data.addressType === 'R') {
      if (data.bname !== '') {
        extraAddress += data.bname;
      }
      if (data.buildingName !== '') {
        extraAddress += extraAddress !== '' ? `, ${data.buildingName}` : data.buildingName;
      }
      fullAddress += extraAddress !== '' ? ` (${extraAddress})` : '';
    }

    //console.log(fullAddress); // e.g. '서울 성동구 왕십리로2길 20 (성수동1가)'
    setValues((prev) => ({
      ...prev,
      address: fullAddress,
      post_code: data?.zonecode,
    }));
    form.setFieldsValue({ address: fullAddress });
    handleCancel();
  };

  return <DaumPostcode onComplete={handleComplete} />;
};

export default Postcode;
